"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPayrollCheckItemDto = instanceOfPayrollCheckItemDto;
exports.PayrollCheckItemDtoFromJSON = PayrollCheckItemDtoFromJSON;
exports.PayrollCheckItemDtoFromJSONTyped = PayrollCheckItemDtoFromJSONTyped;
exports.PayrollCheckItemDtoToJSON = PayrollCheckItemDtoToJSON;
exports.PayrollCheckItemDtoToJSONTyped = PayrollCheckItemDtoToJSONTyped;
/**
 * Check if a given object implements the PayrollCheckItemDto interface.
 */
function instanceOfPayrollCheckItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('zealShiftId' in value) || value['zealShiftId'] === undefined)
        return false;
    if (!('shiftId' in value) || value['shiftId'] === undefined)
        return false;
    return true;
}
function PayrollCheckItemDtoFromJSON(json) {
    return PayrollCheckItemDtoFromJSONTyped(json, false);
}
function PayrollCheckItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'zealShiftId': json['zealShiftId'],
        'shiftId': json['shiftId'],
        'time': json['time'] == null ? undefined : (new Date(json['time'])),
        'hourlyWage': json['hourlyWage'] == null ? undefined : json['hourlyWage'],
        'hourlyMinutes': json['hourlyMinutes'] == null ? undefined : json['hourlyMinutes'],
        'overtimeWage': json['overtimeWage'] == null ? undefined : json['overtimeWage'],
        'overtimeMinutes': json['overtimeMinutes'] == null ? undefined : json['overtimeMinutes'],
        'doubletimeWage': json['doubletimeWage'] == null ? undefined : json['doubletimeWage'],
        'doubletimeMinutes': json['doubletimeMinutes'] == null ? undefined : json['doubletimeMinutes'],
        'flatWage': json['flatWage'] == null ? undefined : json['flatWage'],
        'flatMinutes': json['flatMinutes'] == null ? undefined : json['flatMinutes'],
        'flatAmount': json['flatAmount'] == null ? undefined : json['flatAmount'],
        'discretionaryBonus': json['discretionaryBonus'] == null ? undefined : json['discretionaryBonus'],
        'nondiscretionaryBonus': json['nondiscretionaryBonus'] == null ? undefined : json['nondiscretionaryBonus'],
        'reimbursement': json['reimbursement'] == null ? undefined : json['reimbursement'],
        'commission': json['commission'] == null ? undefined : json['commission'],
    };
}
function PayrollCheckItemDtoToJSON(json) {
    return PayrollCheckItemDtoToJSONTyped(json, false);
}
function PayrollCheckItemDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'zealShiftId': value['zealShiftId'],
        'shiftId': value['shiftId'],
        'time': value['time'] == null ? undefined : (value['time'].toISOString()),
        'hourlyWage': value['hourlyWage'],
        'hourlyMinutes': value['hourlyMinutes'],
        'overtimeWage': value['overtimeWage'],
        'overtimeMinutes': value['overtimeMinutes'],
        'doubletimeWage': value['doubletimeWage'],
        'doubletimeMinutes': value['doubletimeMinutes'],
        'flatWage': value['flatWage'],
        'flatMinutes': value['flatMinutes'],
        'flatAmount': value['flatAmount'],
        'discretionaryBonus': value['discretionaryBonus'],
        'nondiscretionaryBonus': value['nondiscretionaryBonus'],
        'reimbursement': value['reimbursement'],
        'commission': value['commission'],
    };
}
//# sourceMappingURL=PayrollCheckItemDto.js.map